import React, { Component } from "react";
import { Title } from "components/misc";
import { Container } from 'design-react-kit';

import { withRouter } from 'react-router-dom';
import { AdminPage } from "components/forms/admin/AdminPage";

class PageCmsForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      idPage: parseInt(this.props.match.params.idPage) > 0 ? this.props.match.params.idPage : 0,
      title: parseInt(this.props.match.params.idPage) > 0 ? 'Gestione Pagina' : 'Nuova Pagina',
    }
  }

  //--- ---

  render() {

    return (
      <>
        <section className="my-4">
          <Container>
            <Title>{this.state.title}</Title>
            {<AdminPage idPage={this.state.idPage} />}
          </Container>
        </section>
      </>
    );
  }

}

export default withRouter(PageCmsForm);
